import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";
const TaskCategoryTable = ({ permission }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const M_id = queryParams.get("id");
  const userId = localStorage.getItem("id");
  const [loading, setLoading] = useState(false);
  const [taskCategoryData, setTaskCategoryData] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchTaskCategoryData = async () => {
    setLoading(true); // start loader
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);

    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => Swal.showLoading(),
      });

      const result = await fetchFormData("task-category/all", formData, "POST");
      if (result) {
        const taskCategory = result.data || [];
        setTaskCategoryData(taskCategory);
        console.log(taskCategory);
      }
    } catch (error) {
      console.error("Error fetching initial data:", error);
      topTost({
        title: "Failed to load task categories",
        icon: "error",
      });
    } finally {
      setLoading(false); // stop loader
      Swal.close();
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("userId", userId);
    formData.append("moduleId", M_id);
    try {
      const result = await fetchFormData(
        `task-category/toggle-status/${Id}`,
        formData,
        "POST"
      );

      if (result && result.code === 200) {
      await  fetchTaskCategoryData();
        const updatedStatus = Number(
          result?.updated_status ?? result?.user?.status ?? -1
        );
        const statusText =
          updatedStatus === 1
            ? "Active"
            : updatedStatus === 0
            ? "Deactive"
            : "Unknown";

        topTost({
          title: `Status updated successfully : ${statusText}`,
          icon: "success",
        });
      } else {
        topTost({
          title: result?.message,
          icon: "success",
        });
      }
    } catch (error) {
      console.error("Error toggling status:", error?.message || error);
    }
  };

  const columns = [
    ...(permission?.pf_edit === 1 || permission?.pf_status === 1
      ? [
          {
            accessorKey: "actions",
            header: () => "Actions",
            cell: ({ row }) => {
              const id = row.original.id;
              const is_active = row.original.status;
              return (
                <div className="hstack gap-2 justify-content-end">
                  {permission?.pf_edit === 1 && (
                    <span
                      className="cursor-pointer"
                      onClick={() =>
                        navigate(`/task/edit-task-category/${id}?id=${M_id}`)
                      }
                    >
                      <FiEdit3 size={16} />
                    </span>
                  )}
                  {permission?.pf_status === 1 &&
                    (is_active === 1 ? (
                      <MdThumbUp
                        className="cursor-pointer text-success"
                        onClick={() => toggleStatus(id)}
                      />
                    ) : (
                      <MdThumbDown
                        className="cursor-pointer text-secondary"
                        onClick={() => toggleStatus(id)}
                      />
                    ))}
                </div>
              );
            },
            meta: {
              headerClassName: "width-30",
              exportable: false,
            },
          },
        ]
      : []),
    {
      accessorKey: "task_category",
      header: () => "Task Category",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },
    {
      accessorKey: "status",
      header: () => "Status",
      cell: (info) => {
        const val = info.getValue(); // expected to be 1 or 0 (number)
        const isActive = val === 1;

        const label = isActive ? "Active" : "Deactive";
        const styles = {
          backgroundColor: isActive ? "#cce5ff" : "#fff3cd", // Sky blue / Light yellow
          color: isActive ? "#004085" : "#856404", // Dark blue / Dark yellow
          padding: "4px 10px",
          display: "inline-block",
          fontWeight: "bold",
          fontSize: "12px",
          textAlign: "center",
        };

        return <span style={styles}>{label}</span>;
      },
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchTaskCategoryData();
  }, []);
  return (
    <>
      <Table data={taskCategoryData} columns={columns} />
    </>
  );
};
export default TaskCategoryTable;
